// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YVoI","colBig":"styles_colBig__ATf0l","colSmall":"styles_colSmall__1-u25","shopifyNameWrapper":"styles_shopifyNameWrapper__2RWo2"};